import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * THE one hover-hint pattern for the app (locked 2026-10-20, revised same day).
 *   <Hint text="…">Label</Hint>   → plain label; on hover the CURSOR becomes the ⓘ glyph
 *   (`.cursor-hint` in index.css) and an ink tooltip appears. No visible icon at rest.
 * Rules: labels & column headers only (never buttons), only where the label needs interpreting,
 * max 2-3 per card, no underlines, no browser `title` on labels.
 */
export default function Hint({ text, children, side = "top", align = "center", className = "", testId }) {
  if (!text) return children ?? null;
  return (
    <TooltipProvider delayDuration={150} skipDelayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`cursor-hint inline-flex items-center ${className}`} data-testid={testId} data-hint="1"
                tabIndex={0} role="note" aria-label={typeof text === "string" ? text : undefined}>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent side={side} align={align} sideOffset={6}
                        className="max-w-xs border-0 bg-slate-900 px-2.5 py-1.5 text-[11px] font-normal normal-case leading-snug tracking-normal text-white shadow-lg">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
